import type { TopLegendFormatter } from '../../../heat-map/MapWrapper';
import type { HeatMapTypes } from '../../../heat-map';
import { RESIDUAL_ID, RISK_FREE_RATE_ID, TOTAL_ID } from '../../../factor-chart';

const percentFormatter = new Intl.NumberFormat('en-US', {
  useGrouping: true,
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
  style: 'percent',
});

const numberFormatter = new Intl.NumberFormat('en-US', {
  useGrouping: true,
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
});

export const percentTopLegendFormatter: TopLegendFormatter = (value?: number | null) =>
  value == null ? '--' : percentFormatter.format(value);

export const numberTopLegendFormatter = (value?: number | null) => numberFormatter.format(value || 0);

export const getFilterCount = (defaultFactorsLength: number, series: HeatMapTypes.Root[]) => {
  const excludedFactors = [RESIDUAL_ID, TOTAL_ID, RISK_FREE_RATE_ID];
  const factors = series.filter(({ factorId }) => factorId !== undefined && !excludedFactors.includes(factorId));
  return defaultFactorsLength - factors.length;
};
